//const AWSHOST = process.env.AWSHOST || `http://localhost:${8500}`;
import stores from './stores.json';

export const fetchStores = async () => {
    /*return fetch(
        process.env.NODE_ENV === 'development'
            ? 'http://localhost:8500/api/stores'
            : 'http://automaten.eu-north-1.elasticbeanstalk.com/api/stores'
    )
        .then((response) => response.json())
        .catch((error) => {
            console.error(error);
        });*/
    return new Promise((resolve: any, _) => {
        const storeArr: Object[] = stores;
        resolve(storeArr);
    });
};
